import { faAngleDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

type SplitButtonOption =
  | {
      label: string;
      to: string;
      onClick?: never;
    }
  | {
      label: string;
      to?: never;
      onClick: () => void;
    };

type SplitButtonProps = SplitButtonOption & {
  alternatives: SplitButtonOption[];
};

export const SplitButton = ({
  label,
  to,
  onClick,
  alternatives,
}: SplitButtonProps) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-flex" ref={menuRef}>
      {to ? (
        <Link
          to={to}
          className="px-4 py-2 btn btn-primary !rounded-tr-none !rounded-br-none"
        >
          {label}
        </Link>
      ) : (
        <button onClick={onClick} className="px-4 py-2 btn-primary rounded-l">
          {label}
        </button>
      )}

      <button
        onClick={() => setOpen((prev) => !prev)}
        className="px-2 btn-primary rounded-r"
      >
        <FontAwesomeIcon icon={faAngleDown} />
      </button>

      {open && (
        <div
          className="absolute top-full right-0 mt-1 bg-white border border-gray-200 rounded z-10 whitespace-nowrap"
          role="menu"
        >
          {alternatives.map((alt) =>
            alt.to ? (
              <Link
                key={alt.label}
                onClick={() => {
                  setOpen(false);
                }}
                to={alt.to}
                className="block w-full text-left px-4 py-2 text-[#333] hover:text-[#333] hover:bg-[#e6f3fb]"
                role="menuitem"
              >
                {alt.label}
              </Link>
            ) : (
              <button
                key={alt.label}
                onClick={() => {
                  alt.onClick();
                  setOpen(false);
                }}
                className="block w-full text-left px-4 py-2 hover:bg-[#e6f3fb]"
                role="menuitem"
              >
                {alt.label}
              </button>
            ),
          )}
        </div>
      )}
    </div>
  );
};

export default SplitButton;
